module.exports = __webpack_public_path__ + "img/9788936456139.393a7aeb.jpg";